import React from 'react';
import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import CheckoutList from '../checkout-components/CheckoutList';
import { useBuilderStore } from '../../../store/checkoutBuilder/BuilderContext';

interface ListAdapterProps {
  componentId: string;
  selected: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
}

const ListAdapter: React.FC<ListAdapterProps> = ({ componentId, selected, dragHandleProps }) => {
  const { state, selectNode, deleteNode, duplicateNode } = useBuilderStore();
  const component = state.document.nodes[componentId];

  if (!component || component.type !== 'component') {
    return null;
  }

  return (
    <CheckoutList
      selected={selected}
      config={component.props || {}}
      onSelect={() => selectNode(componentId)}
      onDelete={() => {
        if (window.confirm('Tem certeza que deseja excluir esta lista?')) {
          deleteNode(componentId);
        }
      }}
      onDuplicate={() => duplicateNode(componentId)}
      dragHandleProps={dragHandleProps}
    />
  );
};

export default ListAdapter;
